<template>
  <!-- slot:插槽。 -->
  <div class="ui button" :class="cClass">
    <template v-if='animated'>
  <!-- $slots表示收集到的所有的插槽 -->
  <!-- hidden content 是在semantic-ui约定的类 -->
  <!-- visible content 是在semantic-ui约定的类 -->
      <div v-if="$slots.hidden"  class="hidden content">
          <!-- 具名插槽 -->
          <slot name="hidden"></slot>
      </div>
      <div v-if="$slots.visible"  class="visible content">
          <!-- 具名插槽 -->
          <slot name="visible"></slot>
      </div>
    </template>
    <template v-else>
      <!-- 不带动画效果的按钮 -->
      <!-- 如果用户设置了icon属性，则显示图标 -->
      <i v-if="icon" class="icon" :class="icon"></i>
     <slot>我是默认内容</slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MyButton',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator (val) {
       
        return ['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'].includes(val)
      }
    },
    icon: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      // 默认 不是 禁用状态
      default: false
    },
    loading: {
      type: Boolean,
      // 默认 不要启用loading状态
      default: false
    },
    animated: {
      type: String,
      default: ''
    }
  },
  computed: {
    cClass () {
      var classArr = [this.size]
      // 当前用户是否启用动画
      // 如果启用了动画，要添加两个类 : animated 动画的名字
      this.animated && classArr.push(`animated ${this.animated}`)
      this.loading && classArr.push('loading')
      this.disabled && classArr.push('disabled')

      return classArr.join(' ')
    }
  }
}
</script>

<style scoped lang='less'></style>